import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=2666129a&scoped=true&"
import script from "./reports.vue?vue&type=script&lang=js&"
export * from "./reports.vue?vue&type=script&lang=js&"
import style0 from "./reports.vue?vue&type=style&index=0&id=2666129a&prod&scoped=true&lang=css&"
import style1 from "./reports.vue?vue&type=style&index=1&id=2666129a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2666129a",
  null
  
)

export default component.exports